$calculators = $ '.calculator'

if $calculators.length
	Order = require './order.coffee'

	for calculator in $calculators
		$calculator = $ calculator

		data =
			configs: configs
			total: {}
			_: _

		calcRactive = new Ractive
			magic: true
			el: document.createDocumentFragment()
			template: Ractive.parse $calculator.outerHTML()
			data: data

		$calculator.replaceWith calcRactive.el

		Order = new Order data

		setTotal = (current, optionKey, source) ->
			option = if optionKey is 'general' then configs[current] else source[optionKey]

			if _.isPlainObject option
				if 'active' of option and option.active is false
					exist = calcRactive.get 'total.' + optionKey
					calcRactive.unset 'current.' + optionKey if exist
					return

			if _.isArray current
				cost = 0
				for arrayValue in current
					continue if _.isUndefined arrayValue
					cost += parseInt option[arrayValue].cost if _.isArray option
			else if _.isPlainObject current
				if current.quantity
					if _.isArray option
						return unless _.has option, current.i
						cost = parseInt option[current.i].cost * current.quantity
					else
						cost = parseInt option.cost * current.quantity
				if current.required
					cost = current.required
			else
				if _.isPlainObject option
					if _.has option, 'min'
						cost = parseInt option.cost * current
					else if _.isBoolean current
						cost = if current then option.cost else 0
					else if _.has option, 'items'
						cost = option.cost * current
					else if _.has option, 'cost'
						cost = option.cost

				if _.isArray option
					cost = parseInt option[current].cost

				if _.isNumber option
					cost = if current then parseInt option else 0

			cost = if _.isNaN cost then 0 else cost

			if optionKey is 'os'
				currentCpu = calcRactive.get 'current.cpu'
				if currentCpu? and currentCpu.quantity
					os = source.os[current]
					return unless _.has os, 'architecture'
					if currentCpu.quantity and os.architecture is 'win'
						cost *= currentCpu.quantity
				else
					cost = 0

			if optionKey is 'cpu'
				currentOs = calcRactive.get 'current.os'
				if currentOs
					os = source.os[currentOs]
					return unless _.has os, 'architecture'
					if current.quantity and os.architecture is 'win'
						calcRactive.set 'total.os', current.quantity * parseInt os.cost

			if _.isObject source.winRam
				currentOs = calcRactive.get 'current.os'
				os = source.os[currentOs]

				if os.architecture is 'win'
					if optionKey is 'os'
						currentRam = calcRactive.get 'current.ram'
						totalRam = calcRactive.get 'total.ram'
						winRamMax = parseInt source.winRam.max
						currentWinRam = if currentRam > winRamMax then winRamMax else currentRam
						calcRactive.set 'total.ram', totalRam + source.winRam.cost * currentWinRam

					else if optionKey is 'ram'
						winRamMax = parseInt source.winRam.max
						currentWinRam = if current > winRamMax then winRamMax else current
						cost += source.winRam.cost * currentWinRam
				else
					currentRam = calcRactive.get 'current.ram'
					calcRactive.set 'total.ram', currentRam * source.ram.cost

			calcRactive.set 'total.' + optionKey, cost

		calcRactive.on 'generalChanged', (general) ->
			@updateModel()
			@update()

			$selects = $ @findAll 'select'
			$selects = $selects.not '.formGeneral, .ractive'
			$selects.selectric 'refresh'

			$discount = $ '.discount'
			isVisible = $discount.is ':visible'
			if general.event
				$discount.fadeIn() unless isVisible
			else
				$discount.fadeOut() if isVisible

		calcRactive.on 'order', (event) ->
			event.original.preventDefault()

			Order.submit()

		calcRactive.observe 'general', (generalIndex, oldGeneral, keypath, idx, asd) ->
			return if _.isUndefined generalIndex
			general = configs[generalIndex]

			@set 'total', {}
			@set 'current.general', parseInt generalIndex

			@set 'source', general.options
			@fire 'generalChanged', general

		calcRactive.observe 'source', (newSource) ->
			return if _.isUndefined newSource
			current = @get 'current'
			for currentKey of current
				currentValue = current[currentKey]

				setTotal currentValue, currentKey, newSource

		calcRactive.observe 'current.*', (newCurrent, oldCurrent, keypath, idx) ->
			source = @get('source') || configs
			return unless source

			setTotal newCurrent, idx, source


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/calculator.coffee
 **/